/**
 * A duração como as automações a mostram: `HH:MM:SS`, sempre preenchida, e
 * digitada como num cronômetro — os números entram pela direita.
 */

const SEGUNDO = 1_000;

/** `5_400_000` → `"01:30:00"`. As horas crescem além de dois dígitos quando precisam. */
export function formatarDuracao(ms: number | null): string {
  const total = Math.max(0, Math.round((ms ?? 0) / SEGUNDO));
  const horas = Math.floor(total / 3_600);
  const minutos = Math.floor((total % 3_600) / 60);
  const segundos = total % 60;
  const dois = (n: number) => String(n).padStart(2, '0');
  return `${dois(horas)}:${dois(minutos)}:${dois(segundos)}`;
}

/**
 * Os dígitos digitados como cronômetro: os dois últimos são os segundos, os dois
 * antes, os minutos, e o resto, as horas. `"130"` → 1 min 30 s. Minuto ou
 * segundo acima de 59 vira o que é ("90" segundos → 1 min 30 s).
 */
export function duracaoDosDigitos(texto: string): number {
  const digitos = texto.replace(/\D/g, '').replace(/^0+/, '').slice(-8).padStart(6, '0');
  const segundos = Number(digitos.slice(-2));
  const minutos = Number(digitos.slice(-4, -2));
  const horas = Number(digitos.slice(0, -4));
  return ((horas * 60 + minutos) * 60 + segundos) * SEGUNDO;
}

/** Os dígitos do que a pessoa digitou, no formato do campo, sem corrigir ainda os 59. */
export function textoDosDigitos(texto: string): string {
  const digitos = texto.replace(/\D/g, '').replace(/^0+/, '').slice(-8).padStart(6, '0');
  return `${digitos.slice(0, -4)}:${digitos.slice(-4, -2)}:${digitos.slice(-2)}`;
}
